import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./Header";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { ProductContext } from "../context/AppContext";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";

const Submenu = () => {
  // const { id } = useParams();
  const navigate = useNavigate();
    const location = useLocation();

  const { getRegistration, userId, getMenuList } = useContext(ProductContext);
    const { id, label, submenuItems } = location.state || {};

      const menuItem = getMenuList.find(item => item.label === Number(label));
const menuItem2 = getMenuList.find(item => item.label === label);


      console.log(menuItem2, "menuItem2")


  const routes = all_routes;

  const resolveRoute = (link) => {
  if (typeof link === "string" && link.startsWith("routes.")) {
    const routeKey = link.replace("routes.", "");
    return routes[routeKey] || "/";
  }
  return link;
};

  return (
    <>
      <div className="page-wrapper">
        <div className="content background-color_row">
          <>
            <Header />

            <div className="col-md-12">
              <div className="align-items-center justify-content-between mb-3 background-color_row">
                <div className="my-auto mb-1 mt-4">
                  <h3 className="page-title mb-1 text-center">{label}</h3>
                </div>
              </div>
            </div>
            <div className="row d-flex background-color_row">
      {submenuItems?.length > 0 ? (
        <>
        {submenuItems.map((subItem, index) => (
              <div className="col-xl-3 col-md-6 mb-4" key={subItem.id}>
                                             <Link
  key={index}
  className=""
  to={resolveRoute(subItem.link)}
  state={{
    id: subItem.id,
    label: subItem.label,
    submenuItems: subItem.submenuItems
  }}
>
                                              <div
                                                  className={`card Card_New h-100 border-0 shadow role-card text-center`}
                                                  role="button"
                                              >
                                                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                                                     <div className="display-4 mb-3 text-primary">
                                            <i className="ti ti-file" />
                                        </div>
                                                      <h5 className="card-title fw-semibold">
                                                          {subItem.label}
                                                      </h5>
                                                  </div>
                                              </div>
                                              </Link>
                                          </div>
              ))}
              </>
              ) : (
        <p>No submenu available</p>
      )}
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default Submenu
